import { Style } from '@wix/thunderbolt-becky-types'
import { StylableEditor } from '@wixc3/stylable-panel-drivers'
import * as stylableSantaFlatten from '@wix/stylable-santa-flatten/cjs'
import _ from 'lodash'

const getStylableCompFonts = (styleItem: Style) => {
	const stcss = getSTCSS(styleItem)
	return stylableSantaFlatten.fontStylable.findFontsInCss(stcss, () => true, true)
}

const getSTCSS = (styleItem: Style): string =>
	_.get(styleItem, ['style', 'properties', '$st-css'], _.get(styleItem, ['style', 'properties', 'st-css'], ''))

const getStylableCompCss = (
	stylableEditorInstance: StylableEditor,
	namespace: string,
	styleItem: Style,
	isMobileView: boolean
) => {
	const componentStyle = getSTCSS(styleItem)

	const { stylableDriver } = stylableEditorInstance
	const editorCompStyle = stylableSantaFlatten.addStylableDirectiveRules(componentStyle, isMobileView, {
		breakpoints: true,
		siteColors: true,
		fontClasses: true,
		additionalJsModules: true,
	})

	stylableDriver.writeFile('/currently-transpiling.st.css', '')

	const metaBefore = stylableDriver.stylable.fileProcessor.processContent(
		editorCompStyle,
		'/currently-transpiling.st.css'
	)
	metaBefore.namespace = namespace
	const { meta } = stylableDriver.stylable.transform(metaBefore)
	stylableDriver.applyEditorTransformations(meta)
	return meta.outputAst!.toString()
}

export { getStylableCompCss, getStylableCompFonts }
